/**
 * Salesforce Integration Registration
 * Registers the Salesforce integration with the integration registry
 */

import { IntegrationRegistry } from '../registry/IntegrationRegistry';
import { salesforceIntegrationFactory } from './SalesforceIntegrationFactory';

/**
 * Register Salesforce integration with the global integration registry
 */
export function registerSalesforceIntegration(): void {
  const registry = IntegrationRegistry.getInstance();
  
  registry.register(
    'salesforce-crm',
    'Salesforce CRM',
    'crm',
    'salesforce',
    '1.0.0',
    salesforceIntegrationFactory
  );

  console.log('Salesforce CRM integration registered successfully');
}

/**
 * Unregister Salesforce integration from the registry
 */
export function unregisterSalesforceIntegration(): void {
  const registry = IntegrationRegistry.getInstance();
  registry.unregister('salesforce-crm');
  console.log('Salesforce CRM integration unregistered');
}

// Auto-register when module is imported
registerSalesforceIntegration();